import { put } from '@/axios'

export interface IPUTIMFollowRequest {
  author_id?: string
  user_id?: string
}

export const putIMFollow = async (params: IPUTIMFollowRequest) => {
  const response = await put<null>(`/user/follow`, params)

  return response
}
